import { combineReducers } from 'redux';

import accountReducer from './accountReducer';
import authReducer from './authReducer';
import functionReducer from './functionReducer';
import systemReducer from './systemReducer';
import bidCaseReviewRecuder from './bidCaseReviewReducer';

const rootReducer = combineReducers({
    account: accountReducer,
    auth: authReducer,
    function: functionReducer,
    system: systemReducer,
    bidCaseReview: bidCaseReviewRecuder
});

export default rootReducer;